import { z } from "zod";
import { createResponseSchema, paginationResponseSchema } from "../../../schemas/repository.schemas";
import { taskExecutionDetailsSchema, taskExecutionInfoSchema, taskInfoSchema, taskSchema } from "../../../schemas/task.schemas";

export const taskInfoListResponseSchema = createResponseSchema(paginationResponseSchema.extend({
    content: z.array(taskInfoSchema),

}));
export type TaskInfoListResponseSchemaType = z.infer<typeof taskInfoListResponseSchema>;

export const taskResponseSchema = createResponseSchema(taskSchema);
export type TaskResponseSchemaType = z.infer<typeof taskResponseSchema>;

export const taskExecutionInfoListResponseSchema = createResponseSchema(paginationResponseSchema.extend({
    content: z.array(taskExecutionInfoSchema)
}));
export type TaskExecutionInfoListResponseSchemaType = z.infer<typeof taskExecutionInfoListResponseSchema>;

export const taskExecutionInfoResponseSchema = createResponseSchema(taskExecutionInfoSchema);
export type TaskExecutionInfoResponseSchemaType = z.infer<typeof taskExecutionInfoResponseSchema>;

export const taskExecutionDetailsResponseSchema = createResponseSchema(paginationResponseSchema.extend({
    content: z.array(taskExecutionDetailsSchema)
}));
export type TaskExecutionDetailsResponseSchemaType = z.infer<typeof taskExecutionDetailsResponseSchema>;


